import React from "react";
import { Box, Typography } from "@mui/material";

interface PageHeaderProps {
  title: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => (
  <Box sx={{ paddingY: { xs: "16px", sm: "32px 48px" } }}>
    <Typography
      variant="h4"
      fontWeight="500"
      fontSize={{ xs: "20px", sm: "36px" }}
      mb={{ xs: 2, sm: 3 }}
    >
      {title}
    </Typography>
  </Box>
);

export default PageHeader;
